// Image load error
export const imageLoadError = e => e.target.classList.add('hide')


export default imageLoadError